import classnames from 'classnames';
import { useState } from 'react';

import styles from './DataTable.module.scss';

interface DataTableProps {
  title: string;
  headerIcon?: 'desktop' | 'frontline';
  headers: string[];
  rows: DataRow[];
}

export interface DataRow {
  label: string;
  calculation?: string;
  values: (string | number)[];
  isHeader?: boolean;
}

export default function DataTable({ title, headerIcon, headers, rows }: DataTableProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={classnames(styles.tableContainer, isOpen && styles.open)}>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              {headers.map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr className={styles.sectionHeader}>
              <th colSpan={2}>
                {title}
                {headerIcon && (
                  <span
                    className={styles.workerIcon}
                    role="img"
                    aria-label={headerIcon === 'desktop' ? 'Desktop worker' : 'Frontline worker'}
                  >
                    {headerIcon === 'desktop' ? ' \uD83D\uDCBB' : ' \uD83D\uDC77'}
                  </span>
                )}
              </th>
              <td />
              <td />
              <td />
              <td />
            </tr>
            {rows.map((row, i) => (
              <tr key={i} className={row.isHeader ? styles.sectionHeader : undefined}>
                {row.isHeader ? (
                  <>
                    <th colSpan={2}>{row.label}</th>
                    <td />
                    <td />
                    <td />
                    <td />
                  </>
                ) : (
                  <>
                    <td>{row.label}</td>
                    <td className={styles.calcCol}>{row.calculation || ''}</td>
                    {row.values.map((v, vi) => (
                      <td key={vi}>{v}</td>
                    ))}
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button
        type="button"
        className={styles.toggleButton}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className={styles.toggleLabel}>{isOpen ? 'HIDE FULL TABLE' : 'SHOW FULL TABLE'}</span>
        <svg
          className={classnames(styles.toggleChevron, isOpen && styles.toggleChevronUp)}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M12 15.586l-7.071-7.071 1.414-1.414L12 12.757l5.657-5.656 1.414 1.414L12 15.586z"
          />
        </svg>
      </button>
    </div>
  );
}
